// Bootstrap
import 'bootstrap';

import './header';

// WooCommerce
import './woocommerce/preferred-delivery'
import './woocommerce/checkout-local-pickup'
import './woocommerce/product-quantity'
import './woocommerce/custom'

import './video-click-load';
import './testimonials';

// SCSS
import '../styles/frontend.scss';
